import { v7 as uuid } from "uuid"
import { db } from "../../mp-database"
import { manualAddStudent } from "./manualAddStudent"
import { getExternalStudentId } from "../helpers/getExternalStudentId"
import { UploadRecord, ImportParams } from "../types"

export const processStudentImport = async (
  record: UploadRecord,
  params: ImportParams
): Promise<string | undefined> => {
  const { districtId, schoolId, state } = params

  const id = uuid()
  const time = Date.now()
  const userRef = db.collection("students").doc(id)
  const email = record.email && record.email.trim().toLowerCase()
  const username =
    (record.username && record.username.trim().toLowerCase()) ?? email
  const fullName = `${record.firstName} ${record.lastName}`
  const validated = record.sendInvite?.toLowerCase() === "no"
  const externalStudentId = getExternalStudentId(record)
  const userData = {
    id,
    email,
    username,
    firstName: record.firstName,
    lastName: record.lastName,
    ...(externalStudentId && { externalStudentId }),
    fullName,
    fullname_lower: fullName.toLowerCase().trim(),
    firstName_lower: record.firstName.toLowerCase().trim(),
    lastName_lower: record.lastName.toLowerCase().trim(),
    role: "Student",
    state: state,
    schoolDistrict: districtId,
    school: schoolId,
    lastModified: time,
    created: time,
    validated,
    assessments: {},
    classes: {}
  }

  const schoolRef = db.collection("schools").doc(schoolId)
  const schoolData = { [`students.${id}`]: true }

  const batch = db.batch()

  const sendInvite = record.sendInvite?.toLowerCase()

  // Either the password the row supplied or the one the server generated for a
  // blank cell — the server echoes both back.
  let password: string | undefined

  if (sendInvite === "no") {
    password = await manualAddStudent(id, record.password)
  }

  if (sendInvite === "yes") {
    const inviteId = uuid()
    const inviteRef = db.collection("userInvites").doc(inviteId)

    batch.set(inviteRef, {
      id: inviteId,
      userId: id,
      createdDate: time,
      expirationDate: time + 259200000, // 3 days
      firstName: record.firstName,
      lastName: record.lastName,
      email
    })
  }

  batch.set(userRef, userData)
  batch.update(schoolRef, schoolData)
  await batch.commit()

  return password
}
